// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-methods-section {
  display: flex;
  flex-direction: column-reverse;
  gap: 40px;
}

.payment-methods-section > img {
  width: 100%;
  height: auto;
}

@media screen and (min-width: 768px) {
  .payment-methods-section {
    flex-direction: row;
  }
  
  .payment-methods-section > img {
    width: 50%;
  }
}

.payment-methods-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.payment-methods-container > img {
  height: auto;
  width: 100px;
  aspect-ratio: 1 / 1;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/metodos-pago/metodos-pago.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".payment-methods-section {\n  display: flex;\n  flex-direction: column-reverse;\n  gap: 40px;\n}\n\n.payment-methods-section > img {\n  width: 100%;\n  height: auto;\n}\n\n@media screen and (min-width: 768px) {\n  .payment-methods-section {\n    flex-direction: row;\n  }\n  \n  .payment-methods-section > img {\n    width: 50%;\n  }\n}\n\n.payment-methods-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.payment-methods-container > img {\n  height: auto;\n  width: 100px;\n  aspect-ratio: 1 / 1;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
